<template>
  <v-app>
    <link
      rel="stylesheet"
      href="https://cdnjs.cloudflare.com/ajax/libs/animate.css/4.1.1/animate.min.css"
      integrity="sha512-c42qTSw/wPZ3/5LBzD+Bw5f7bSF2oxou6wEb+I/lqeaKV5FDIfMvvRp772y4jcJLKuGUOpbJMdg/BTl50fJYAw=="
      crossorigin="anonymous"
    />
    <v-main>
      <section id="background">
        <div class="master-title">
          <p>Machinery、Manufacture & Design</p>
          <p class="animate__animated animate__rubberBand" v-show="isShowZhTitle">{{ $t('imacloud') }}</p>
          <p v-show="isShowZhTitle">Intelligent Cloud for Machinery<br class="d-sm-none" /></p>
          <p v-show="!isShowZhTitle" class="en-title font-weight-bold animate__animated animate__rubberBand">Intelligent Cloud for Machinery</p>
        </div>
        <v-menu offset-y nudge-bottom="10">
          <template v-slot:activator="{ on: menu, attrs }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on: tooltip }">
                <v-btn id="lang" icon v-bind="attrs" v-on="{ ...tooltip, ...menu }">
                  <v-icon>mdi-web</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('language') }}</span>
            </v-tooltip>
          </template>
          <v-list dense class="pa-0" color="_light_grey">
            <template v-for="item in localeItems">
              <v-list-item :key="item" @click="changeLocaleHandler(item)">
                <v-list-item-title>{{ $t(item) }} </v-list-item-title>
              </v-list-item>
              <v-divider class="ma-0" :key="'divider_' + item" />
            </template>
          </v-list>
        </v-menu>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn id="login" icon v-bind="attrs" v-on="on" @click="signInUrl()">
              <v-icon>mdi-account</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('signIn') + '/' + $t('signUp') }}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn id="service" icon v-bind="attrs" v-on="on" @click="routerHandler('https://portal.imacloud.com.tw/#/serviceSite')">
              <v-icon>mdi-hand-heart</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('serviceSite') }}</span>
        </v-tooltip>
        <div class="planet-box">
          <p>
            <a @click="routerHandler('https://portal.imacloud.com.tw/#/?locale=' + locale)" id="ma">
              <img src="@/assets/Ma.png" alt="Machinery cloud" class="img-fluid animate__animated animate__headShake animate__delay-1s" />
            </a>
          </p>
          <p>
            <a href="https://manufacture.imacloud.com.tw/" id="man">
              <img src="@/assets/Man.png" alt="Manufacture cloud" class="img-fluid animate__animated animate__headShake animate__delay-2s" />
            </a>
          </p>
          <p>
            <a href="https://imtc.itri.org.tw/Loginima.aspx" id="de">
              <img src="@/assets/De.png" alt="Design cloud" class="img-fluid animate__animated animate__headShake animate__delay-1s" />
            </a>
          </p>
        </div>
      </section>
      <section id="else-logo">
        <div class="container">
          <div class="row no-gutters">
            <div class="col-md-3">
              <a id="smb-btn" @click="routerHandler('https://portal.imacloud.com.tw/#/downloadZone')">
                <img src="@/assets/smb.png" alt="Smb cloud" class="img-fluid animate__animated animate__headShake animate__delay-2s" />
              </a>
            </div>
            <CarouselMultiPic :items="carouselLogo" :showCount="1" :hideDelimiter="true" />
          </div>
        </div>
      </section>
    </v-main>
  </v-app>
</template>

<style src="./css/bootstrap.min.css"></style>
<style src="./css/style.css"></style>

<script>
import { mapGetters } from 'vuex';
import CarouselMultiPic from '@/components/CarouselMultiPic.vue';
import File from '@/api/file';

export default {
  name: 'Home',
  components: { CarouselMultiPic },
  data: () => ({
    logoList: null,
  }),
  created() {
    let language = null;
    if (Object.keys(this.$route.query).length && Object.prototype.hasOwnProperty.call(this.$route.query, 'locale')) {
      language = this.$route.query.locale;
    } else {
      language = window.localStorage.getItem('locale');
    }
    if (language !== null) {
      this.$store.commit('locale/set', { locale: language });
    }
    this.loadLogo();
  },
  computed: {
    ...mapGetters('locale', ['locale', 'localeItems']),
    isShowZhTitle() {
      return this.locale === 'zh-tw';
    },
    carouselLogo() {
      if (this.logoList == null) return [];
      return this.logoList.logo.map((x) => process.env.VUE_APP_S3_URL + x);
    },
  },
  methods: {
    signInUrl() {
      if (process.env.VUE_APP_SSO === 'oauth2') {
        try {
          File.api(`https://${process.env.VUE_APP_API_GATEWAY_ID}.execute-api.${process.env.VUE_APP_AWS_REGION}.amazonaws.com/Prod/oauth`, 'POST', {
            operation: 'loginUrl',
            redirectUrl: 'https://portal.imacloud.com.tw/',
          }).then((res) => {
            this.routerHandler(res.data.data);
          });
        } catch (err) {
          console.log(`Failed to get sign in url! ${err}`);
        }
      } else {
        this.routerHandler('https://portal.imacloud.com.tw/#/account/signIn');
      }
    },
    routerHandler(href) {
      window.location.href = href;
    },
    changeLocaleHandler(lang) {
      this.$store.commit('locale/set', { locale: lang });
      window.localStorage.setItem('locale', lang);
    },
    loadLogo() {
      try {
        File.api('info.json').then((res) => {
          this.logoList = res.data;
        });
      } catch (err) {
        console.log(`Failed to load logo! ${err}`);
      }
    },
  },
};
</script>

<style>
html {
  overflow: auto !important;
  /* scrollbar-width: none; */
  /* -ms-overflow-style: none; */
}
/* html::-webkit-scrollbar {
  width: 0;
  height: 0;
} */
</style>
